import { Fragment, useState } from "react";
import Search from "../../../form/Search";
import Accordian from "../../../elements/Accordian";
import Switch from "../../../form/Switch";
import Badge from "../../../elements/Badge";
import Button from "../../../form/Button";

const UserPrivilege = () => {
  const selectedData = {
    name: "Tesla Analytics",
    icon: "🔴",
    verified: true,
    description: "Premium workspace with full access",
    privilege: [
      {
        name: "Pages",
        access: "Full",
        description:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        enabled: true,
        iconClass: "fas fa-file-alt",
      },
      {
        name: "Forms",
        access: "Full",
        description: "Allow management access to forms controls",
        enabled: true,
        iconClass: "fas fa-file-alt",
      },
      {
        name: "Users",
        access: "None",
        description: "Allow management access to users controls",
        enabled: false,
        iconClass: "fas fa-users",
      },
      {
        name: "Groups",
        access: "None",
        description: "Allow management access to groups controls",
        enabled: false,
        iconClass: "fas fa-user",
      },
      {
        name: "Permissions",
        access: "None",
        description: "Allow management access to permissions controls",
        enabled: false,
        iconClass: "fas fa-shield-alt",
      },
    ],
  };
  const [selectedWorkspace, setSelectedWorkspace] = useState(selectedData);
  const [workspaceSearch, setWorkspaceSearch] = useState("");
  const [privileges, setPrivileges] = useState([
    {
      name: "Pages",
      access: "Full",
      description: "Allow management access to pages controls",
      enabled: true,
      iconClass: "fas fa-file-alt",
    },
    {
      name: "Forms",
      access: "Full",
      description: "Allow management access to forms controls",
      enabled: true,
      iconClass: "fas fa-file-alt",
    },
    {
      name: "Users",
      access: "None",
      description: "Allow management access to users controls",
      enabled: false,
      iconClass: "fas fa-users",
    },
    {
      name: "Groups",
      access: "None",
      description: "Allow management access to groups controls",
      enabled: false,
      iconClass: "fas fa-user",
    },
    {
      name: "Permissions",
      access: "None",
      description: "Allow management access to permissions controls",
      enabled: false,
      iconClass: "fas fa-shield-alt",
    },
  ]);

  const workspaces = [
    {
      name: "Tesla Analytics",
      icon: "🔴",
      verified: true,
      description: "Premium workspace with full access",
      privilege: [
        {
          name: "Pages",
          access: "Full",
          description:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
          enabled: true,
          iconClass: "fas fa-file-alt",
        },
        {
          name: "Forms",
          access: "Full",
          description:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
          enabled: true,
          iconClass: "fas fa-file-alt",
        },
        {
          name: "Users",
          access: "None",
          description: "Allow management access to users controls",
          enabled: false,
          iconClass: "fas fa-users",
        },
        {
          name: "Groups",
          access: "None",
          description: "Allow management access to groups controls",
          enabled: false,
          iconClass: "fas fa-user",
        },
        {
          name: "Permissions",
          access: "None",
          description: "Allow management access to permissions controls",
          enabled: false,
          iconClass: "fas fa-shield-alt",
        },
      ],
    },
    {
      name: "MSD Sanket Analytics",
      icon: "📊",
      verified: false,
      description: "Standard workspace with limited access",
      privilege: [
        {
          name: "Pages",
          access: "Full",
          description:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
          enabled: true,
          iconClass: "fas fa-file-alt",
        },
        {
          name: "Forms",
          access: "Full",
          description: "Allow management access to forms controls",
          enabled: true,
          iconClass: "fas fa-file-alt",
        },
        {
          name: "Users",
          access: "None",
          description: "Allow management access to users controls",
          enabled: false,
          iconClass: "fas fa-users",
        },
      ],
    },
    {
      name: "MSD JWT",
      icon: "📈",
      verified: false,
      description: "Basic workspace with view-only access",
      privilege: [
        {
          name: "Pages",
          access: "Full",
          description: "Allow management access to pages controls",
          enabled: true,
          iconClass: "fas fa-file-alt",
        },
        {
          name: "Groups",
          access: "None",
          description: "Allow management access to groups controls",
          enabled: false,
          iconClass: "fas fa-user",
        },
        {
          name: "Permissions",
          access: "None",
          description: "Allow management access to permissions controls",
          enabled: false,
          iconClass: "fas fa-shield-alt",
        },
      ],
    },
  ];

  const [openPrivilege, setOpenPrivilege] = useState(null);

  const togglePrivilege = (index) => {
    setSelectedWorkspace((prev) => {
      const newPrivs = [...prev.privilege];
      newPrivs[index].enabled = !newPrivs[index].enabled;
      return { ...prev, privilege: newPrivs };
    });
  };

  // Filter workspaces based on search input (case-insensitive)
  const filteredWorkspaces = workspaces.filter((ws) =>
    ws.name.toLowerCase().includes(workspaceSearch.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-blue-50 to-purple-50 p-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-medium mb-6 text-gray-900 text-center">
          Workspace & Privileges Dashboard
        </h1>

        <div className="flex gap-4">
          {/* Workspaces (LEFT) with fixed small width */}
          <section className="w-72 bg-white rounded-3xl shadow-md border border-gray-200 p-6">
            <h2 className="text-xl font-semibold mb-4">Workspaces</h2>

            {/* Search input */}
            <div className="w-60 mb-6 py-2">
              <Search
                placeholder={"Search here"}
                search={(val) => {
                  setWorkspaceSearch(val);
                }}
              />
            </div>

            <ul className="space-y-4 max-h-[70vh] overflow-y-auto">
              {filteredWorkspaces.length > 0 ? (
                filteredWorkspaces.map((ws) => {
                  const isSelected = selectedWorkspace.name === ws.name;
                  return (
                    <li
                      key={ws.name}
                      className={`flex items-center space-x-4 p-4 rounded-xl cursor-pointer border
                        ${
                          isSelected
                            ? "border-indigo-500 bg-indigo-100 text-indigo-700 font-semibold"
                            : "border-transparent hover:border-indigo-300 hover:bg-indigo-50"
                        }
                      `}
                      onClick={() => setSelectedWorkspace(ws)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") setSelectedWorkspace(ws);
                      }}
                    >
                      <span className="text-2xl select-none">{ws.icon}</span>
                      <div>
                        <div className="flex items-center space-x-2">
                          <span>{ws.name}</span>
                          {ws.verified && (
                            <i
                              className="fas fa-check-circle text-green-500 w-5 h-5"
                              title="Verified"
                              aria-label="Verified"
                            />
                          )}
                        </div>
                        <p className="text-sm text-gray-500">
                          {ws.description}
                        </p>
                      </div>
                    </li>
                  );
                })
              ) : (
                <p className="text-gray-500 text-center mt-4">
                  No workspaces found.
                </p>
              )}
            </ul>
          </section>

          {/* Privileges (RIGHT) takes remaining space */}
          <section className="flex-1 bg-white rounded-3xl shadow-md border border-gray-200 p-6 max-h-[70vh] overflow-y-auto">
            <h2 className="text-xl font-semibold mb-4">Editor Privileges</h2>
            <div className="divide-y divide-gray-200">
              <Accordian
                className="divide-y divide-gray-200"
                data={selectedWorkspace.privilege.map((priv, idx) => ({
                  buttonClass: `flex items-center gap-4 ${
                    priv.enabled
                      ? "bg-blue-100 text-blue-800 font-semibold"
                      : "bg-gray-50 text-gray-800 hover:bg-blue-50"
                  }`,
                  contentClass: "text-blue-700 bg-blue-50 rounded-b-xl",
                  title: (
                    <Fragment>
                      <div className="flex w-full justify-between items-center">
                        <div className="flex justify-cender items-center gap-2">
                          <div className="p-2 rounded-xl bg-white shadow flex items-center justify-center">
                            <i
                              className={`${priv.iconClass} ${
                                priv.enabled
                                  ? "text-green-600"
                                  : "text-gray-400"
                              } w-5 h-5`}
                              aria-hidden="true"
                            />
                          </div>
                          <div className="font-medium">{priv.name}</div>
                          <div
                            className={`text-xs mt-1 px-2 py-0.5 rounded-full font-semibold w-fit ${
                              priv.access === "Full"
                                ? "bg-green-200 text-green-800"
                                : "bg-gray-300 text-gray-600"
                            }`}
                          >
                            Access: {priv.access}
                          </div>
                        </div>
                        <div
                          onClick={(e) => e.stopPropagation()}
                          className="flex gap-2 items-center"
                        >
                          <Switch
                            className={`flex items-center rounded-full p-1 cursor-pointer transition 
                           ${priv.enabled ? "bg-green-500" : "bg-gray-300"}
                          `}
                            checked={priv.enabled}
                            onChange={(e) => {
                              togglePrivilege(idx);
                            }}
                          />
                          <Badge
                            type={priv.enabled ? "success" : "danger"}
                            label={priv.enabled ? "Active" : "Inactive"}
                          />
                        </div>
                      </div>
                    </Fragment>
                  ),
                  content: <p>{priv.description}</p>,
                }))}
              />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default UserPrivilege;
